import React from "react";
import { BackgroundImage, TeethLogo, ServiceBottomButton } from "../../Components"
import endodontic_dentistry from "../../assets/Images/endodontic-dentistry_home.jpg"

const EndodonticDentistry = (props) => {
    const { selectedLanguage } = props

    return (
        <div className="main">
            <BackgroundImage heading={selectedLanguage?.services_endodontic_dentistry_heading} text={selectedLanguage?.txt_explore_our_services} mainClass='endodontic-dentistry-background' />
            <TeethLogo heading={selectedLanguage?.services_endodontic_dentistry_heading} />
            <div className="dental-service-main">
                <div className="dental-service-img-div">
                    <img src={endodontic_dentistry} alt="dentalImg" />
                </div>
                <div className="dental-service-text-div">
                    <p>{selectedLanguage?.endodontic_paragraph_of_all_dental_treatment}</p>
                    <p>{selectedLanguage?.endodontic_paragraph_howver_one_of_our_main_concern}</p>
                    <p>{selectedLanguage?.endodontic_paragraph_in_addition_by_importing_and_sharing_experince}</p>
                    <p>{selectedLanguage?.endodontic_paragraph_both_pain_and_worry_during_visites}</p>
                </div>
            </div>
            <ServiceBottomButton {...props} />
        </div>
    )
}

export default EndodonticDentistry